import { useQuery } from '@tanstack/react-query'
import { useLocalisation } from '~/context/localisation'
import { usePartner } from '~/context/partner'
import { getAviosOnlyPromotion } from '~/services/contentService'

export const useAviosOnlyPromotion = () => {
  const { locale } = useLocalisation()
  const partner = usePartner()

  const { data: aviosOnlyPromotionContent, isLoading } = useQuery({
    queryKey: ['aviosOnlyPromotion', partner.tag, locale],
    queryFn: ({ signal }) => getAviosOnlyPromotion(partner.tag, signal, locale),
  })

  return { aviosOnlyPromotionContent, isLoading }
}
